$(document).ready(function(){

  function insertBundleInfo() {
    if($('.mbc-bundle-vd__offer-list .mbc-bundle-vd__offer .mbc-bundle-vd__offer-title p').length) {
      return;
    }
    $('.mbc-bundle-vd__offer-list .mbc-bundle-vd__offer').each(function () {
      let bundleQuantityValue = $(this).find('input').val();
      let bundleInfo = $('<p></p>');

      switch (bundleQuantityValue) {
        case '1':
          bundleInfo.text('A daily dose of affirmation. For you, or someone who needs to feel seen today.');
          break;
        case '4':
          bundleInfo.text('One for you, three to gift - or stock your closet.');
          break;
        case '6':
          bundleInfo.text('Great for group gifting, sister circles, and surprise blessings.');
          break;
        case '12':
          bundleInfo.text('For the auntie, organizer, or church mom who gives with intention year-round.');
          break;
      }

      $(this).find('.mbc-bundle-vd__offer-title').append(bundleInfo);
    });
  }


  setInterval(() => {
    insertBundleInfo();
  }, 100);


  function updatePriceWrapper () {
    let price = $('.mbc-bundle-vd__offer input:checked + label .mbc-bundle-vd__offer-price')?.text();
    let compare_price = $('.mbc-bundle-vd__offer input:checked + label .mbc-bundle-vd__offer-compare-at-price').text();
    if(compare_price == '' || compare_price == undefined) {
      compare_price = '';
    }
    let savePercent = $('.mbc-bundle-vd__offer input:checked + label .mbc-bundle-vd__offer-percent')?.text();
    if(savePercent == '' || savePercent == undefined) {
      savePercent = '';
    } else {
      savePercent = ' Save ' + savePercent;
    }

    $('.product-block--price .product__price.on-sale').text(price);
    $('.product-block--price .product__price.product__price--compare').text(compare_price);
    $('.product-block--price .product__price-savings').text(savePercent);
  }

  $(document).on('change', '.mbc-bundle-vd__offer input', function(){
    updatePriceWrapper();
  });
});